<template>
	<div class="py-2 px-3 my-2 mx-3" :class="{'border-2 border-yellow-400 rounded relative': markAsMe}">
		<div v-if="markAsMe"
			class="absolute -top-3 z-50 bg-gray-800 left-0 text-white px-2 font-bold"
		>
			YOU
		</div>
		<div class="flex flex-nowrap items-start">
			<div>
				<div class="font-bold text-white text-xl flex items-center">
					<div
						class="bg-gray-750 rounded-md px-2 py-0.5 flex items-center justify-center mr-3 font-bold text-base text-white">
						<svg class="w-6 h-6 py-1 text-yellow-500" viewBox="0 0 23 20" fill="currentColor"
							 v-if="leader.position === 1">
							<path
								d="M22.5 5.3125C22.5 6.17539 21.8004 6.875 20.9375 6.875C20.9278 6.875 20.9197 6.87005 20.91 6.8699L18.9366 17.7254C18.8281 18.3164 18.3125 18.75 17.707 18.75H4.79297C4.18906 18.75 3.67109 18.318 3.56328 17.7238L1.59023 6.87109C1.58047 6.87109 1.57227 6.875 1.52734 6.875C0.664453 6.875 -0.0351562 6.17539 -0.0351562 5.3125C-0.0351562 4.44961 0.699609 3.75 1.52734 3.75C2.35508 3.75 3.08984 4.44961 3.08984 5.3125C3.08984 5.66398 2.9523 5.97227 2.75637 6.2332L6.25754 9.03398C6.87902 9.53125 7.80051 9.32867 8.15637 8.6168L10.4064 4.1168C9.96484 3.84141 9.65234 3.37266 9.65234 2.8125C9.65234 1.94961 10.3867 1.25 11.25 1.25C12.1133 1.25 12.7773 1.94961 12.7773 2.8125C12.7773 3.37266 12.4663 3.84141 12.0234 4.11719L14.2734 8.61719C14.6293 9.32891 15.5512 9.53125 16.1723 9.03438L19.6734 6.23359C19.5117 5.97266 19.375 5.62891 19.375 5.3125C19.375 4.44922 20.0742 3.75 20.9375 3.75C21.8008 3.75 22.5 4.44922 22.5 5.3125Z"/>
						</svg>
						<span v-else><span class="text-gray-500">#</span>{{ leader.position }}</span>
					</div>

					<span class="truncate text-ellipsis">{{ decodeURIComponent(leader.display_name) }}</span>
				</div>
				<div class="rank font-bold uppercase text-sm"
					 :class="rankColor">{{ leader.rank }}
				</div>
			</div>

			<div class="points font-bold text-lg ml-auto">
				{{ leader.score }}<span class="hidden sm:inline"> points</span>
			</div>
		</div>

		<div class="mt-2 flex items-end text-sm align-middle items-center" v-if="leader.awards">
			<GiftIcon class="inline w-7 h-7 mr-2"/>
			<p>{{ (leader.awards || []).join(', ') }}</p>
		</div>
	</div>
</template>

<script lang="ts" setup>

import {GiftIcon} from '@heroicons/vue/24/outline'
import {LeaderboardUser2} from "../api";
import {computed} from "vue";

const props = defineProps<{
	leader: LeaderboardUser2,
	markAsMe: boolean
}>()

const rankColor = computed(() => {
switch (props.leader.rank) {
		case 'user':
			return 'text-green-500'
		case 'elite':
			return 'text-red-500'
		case 'admin':
			return 'text-blue-500'
		case 'mod':
			return 'text-blue-500'
	}
})
</script>
